import { PartnerPaymentStatus } from '../../models/payments/types';
import { SvgIconComponent } from '@mui/icons-material';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import SyncIcon from '@mui/icons-material/Sync';

interface PartnerPaymentStatusMeta {
  title: string;
  description: string;
  Icon: SvgIconComponent;
  bannerImage: string;
  bgColor: string;
  color: string;
  nextStep: string;
}

type PartnerPaymentStatusMap = Record<
  PartnerPaymentStatus,
  PartnerPaymentStatusMeta
>;

export const statusMap: PartnerPaymentStatusMap = {
  [PartnerPaymentStatus.PENDING]: {
    title: 'status.pending.title',
    description: 'status.pending.description',
    Icon: PendingActionsIcon,
    bannerImage:
      'https://i.ibb.co/VYvpPm8d/Gemini-Generated-Image-q9ya6sq9ya6sq9ya.png',
    bgColor: 'bg-yellow-100',
    color: 'text-yellow-800',
    nextStep: 'status.pending.next_step',
  },
  [PartnerPaymentStatus.COMPLETED]: {
    title: 'status.completed.title',
    description: 'status.completed.description',
    Icon: PriceCheckIcon,
    bannerImage:
      'https://i.ibb.co/bgDwVjTb/Gemini-Generated-Image-b9ehgkb9ehgkb9eh.png',
    bgColor: 'bg-green-100',
    color: 'text-green-800',
    nextStep: 'status.completed.next_step',
  },
  [PartnerPaymentStatus.FAILED]: {
    title: 'status.failed.title',
    description: 'status.failed.description',
    Icon: WarningAmberIcon,
    bannerImage:
      'https://i.ibb.co/jZ64Frcf/Gemini-Generated-Image-lu160ulu160ulu16.png',
    bgColor: 'bg-red-100',
    color: 'text-red-800',
    nextStep: 'status.failed.next_step',
  },
  [PartnerPaymentStatus.DECLINED]: {
    title: 'status.declined.title',
    description: 'status.declined.description',
    Icon: ThumbDownAltIcon,
    bannerImage:
      'https://i.ibb.co/chKRsxqs/Gemini-Generated-Image-tes283tes283tes2.png',
    bgColor: 'bg-red-100',
    color: 'text-red-800',
    nextStep: 'status.declined.next_step',
  },
  [PartnerPaymentStatus.DELAYED]: {
    title: 'status.delayed.title',
    description: 'status.delayed.description',
    Icon: HourglassTopIcon,
    bannerImage:
      'https://i.ibb.co/60wFjdhp/Gemini-Generated-Image-cjd6q3cjd6q3cjd6.png',
    bgColor: 'bg-yellow-100',
    color: 'text-yellow-800',
    nextStep: 'status.delayed.next_step',
  },
  [PartnerPaymentStatus.WAITING_FOR_INVOICE]: {
    title: 'status.waiting_for_invoice.title',
    description: 'status.waiting_for_invoice.description',
    Icon: UploadFileIcon,
    bannerImage:
      'https://i.ibb.co/Pv6jQbFv/Gemini-Generated-Image-1acqyr1acqyr1acq.png',
    bgColor: 'bg-blue-100',
    color: 'text-blue-800',
    nextStep: 'status.waiting_for_invoice.next_step',
  },
  [PartnerPaymentStatus.IN_REVIEW]: {
    title: 'status.in_review.title',
    description: 'status.in_review.description',
    Icon: RestartAltIcon,
    bannerImage:
      'https://i.ibb.co/LFNj3Jv/Gemini-Generated-Image-ytgngbytgngbytgn.png',
    bgColor: 'bg-yellow-100',
    color: 'text-yellow-800',
    nextStep: 'status.in_review.next_step',
  },
  [PartnerPaymentStatus.NO_EARNINGS]: {
    title: 'status.no_earnings.title',
    description: 'status.no_earnings.description',
    Icon: MoneyOffIcon,
    bannerImage:
      'https://i.ibb.co/Fqxj2nrB/Gemini-Generated-Image-pkqm0wpkqm0wpkqm.png',
    bgColor: 'bg-gray-100',
    color: 'text-gray-800',
    nextStep: 'status.no_earnings.next_step',
  },
  [PartnerPaymentStatus.PROCESSING_PAYMENT]: {
    title: 'status.processing_payment.title',
    description: 'status.processing_payment.description',
    Icon: SyncIcon,
    bannerImage:
      'https://i.ibb.co/wZNMt80h/Gemini-Generated-Image-aygsjvaygsjvaygs.png',
    bgColor: 'bg-blue-100',
    color: 'text-blue-800',
    nextStep: 'status.processing_payment.next_step',
  },
};
